import { PROPERTY_TYPES, STRUCTURE_TYPES, CITY_PLANNING_TYPES, LAYOUT_TYPES, RENOVATION_TYPES } from "./options";

export const getPropertyTypeLabel = (key: string) => {
  const type = PROPERTY_TYPES.find((t) => t.key === key);
  return type ? type.label : "";
};

export const getStructureTypeLabel = (key: string) => {
  const type = STRUCTURE_TYPES.find((t) => t.key === key);
  return type ? type.label : "";
};

export const getCityPlanningLabel = (key: string) => {
  const type = CITY_PLANNING_TYPES.find((t) => t.key === key);
  return type ? type.label : "";
};

export const getLayoutLabel = (key: string) => {
  const type = LAYOUT_TYPES.find((t) => t.key === key);
  return type ? type.label : "";
};

export const getRenovationLabel = (key: string) => {
  const type = RENOVATION_TYPES.find((t) => t.key === key);
  return type ? type.label : "";
};
